export default "__VITE_ASSET__r$9dBkdI__"